var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameover02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1288.85 375.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#New_Gradient_Swatch_103);}.cls-10,.cls-16,.cls-5{mix-blend-mode:screen;}.cls-5{fill:url(#radial-gradient);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#radial-gradient-2);}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#New_Gradient_Swatch_102);}.cls-13{fill:url(#New_Gradient_Swatch_102-2);}.cls-14{fill:url(#New_Gradient_Swatch_104);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{opacity:0.3;fill:url(#radial-gradient-3);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 102.01,
    y1: 306.79,
    x2: 250.02,
    y2: 246.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e0103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3e0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#540a0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#610e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#660f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#600e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4f0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#380808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 191.44,
    y1: 271.94,
    x2: 262.98,
    y2: 271.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#420000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a1f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_103",
    x1: 81.74,
    y1: 263.57,
    x2: 160.74,
    y2: 231.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#660f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#c4353c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ad292e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#6a0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#610000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 86.97,
    cy: 130.31,
    r: 210.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1625.24,
    y1: 416.41,
    x2: -1547.32,
    y2: 384.93,
    gradientTransform: "translate(1704.44 -159.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6b4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffc261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b4200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1038.83,
    y1: 246.99,
    x2: 1186.85,
    y2: 306.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#380808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#4f0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#600e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#660f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#610e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#540a0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#3e0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e0103"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1025.87,
    y1: 271.94,
    x2: 1097.41,
    y2: 271.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#420000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1128.11,
    y1: 231.65,
    x2: 1207.11,
    y2: 263.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#610000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6a0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ad292e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#c4353c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660f0f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 1230.96,
    cy: 124.49,
    r: 209.33,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -572.7,
    y1: 384.93,
    x2: -494.78,
    y2: 416.41,
    gradientTransform: "translate(1704.44 -159.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffc261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6b4200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_102",
    cx: -71,
    cy: 265.65,
    r: 730.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#701d24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#cc4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#b22e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#9c1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#8c0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#830303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "maroon"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#990d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a81414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad1717"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_102-2",
    cx: -3345.36,
    cy: 265.65,
    r: 730.47,
    gradientTransform: "matrix(-1, 0, 0, 1, -1985.5, 0)",
    xlinkHref: "#New_Gradient_Swatch_102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_104",
    x1: 139.01,
    y1: 147.32,
    x2: 644.9,
    y2: 147.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d69705"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#ffdd6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#eba605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 644.9,
    y1: 146.95,
    x2: 1151.03,
    y2: 146.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#eba605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ffdd6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d69705"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 644.43,
    cy: 387.12,
    r: 635.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d11919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#911115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4a0911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#1e030e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0d010d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 363.39,
    y1: 162.05,
    x2: 363.39,
    y2: 72.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffec59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 443.24,
    y1: 162.38,
    x2: 443.24,
    y2: 71.41,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 526.7,
    y1: 163.9,
    x2: 526.7,
    y2: 74.22,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 610.71,
    y1: 162.14,
    x2: 610.71,
    y2: 70.54,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 720.91,
    y1: 161.2,
    x2: 720.91,
    y2: 74.65,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 790.55,
    y1: 155.85,
    x2: 790.55,
    y2: 71.99,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 861.3,
    y1: 162.14,
    x2: 861.3,
    y2: 70.54,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 937.7,
    y1: 162.99,
    x2: 937.7,
    y2: 72.05,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 987.35,
    y1: 159.64,
    x2: 987.35,
    y2: 74.43,
    xlinkHref: "#linear-gradient-9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.3,354.38c31.64,23.63,112.7,6,131.07-21,3.48-5.13,5.74-11.1,4.61-18.81.59-2.39-38.67-111.85-41.9-139.15-2.39,31.86-93.64,38.3-116.4,32-7.53,32.56-5.76,127.68,22.62,147Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192.42,274.92c-6.31-28.29,18.85-44.36,47.87-45.56,8.94,41.16,15.94,61.49,22.69,85.17-8.55-29.11-63.85-9.52-70.56-39.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.42,156.63c8.92,36.16,38.1,119.48,54.59,150.75-15.5-20.35-49.2-13.24-62,6.27-7,10.68-8.52,30.18,4.27,40.73-4.3-2.43-16.37-11.95-21.94-34.49C97.55,288.31,76.83,230.78,61,198c-16-33,36.73-63.27,69.46-41.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.22,150.51a53.92,53.92,0,0,0-22,10.53c9.25,12,55.08,131.21,54,149.73A43.48,43.48,0,0,1,146.38,297c-12.76-21.64-50-132.47-53.16-146.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.89,173q-1.27-4.35-2.34-8.27c-19.7-12.87-46.83-6.63-61.12,7.76-7.74,7.77-11.79,18.13-8.87,28.79q1.55,3.3,3.14,6.86c-2-9.87,1.89-19.56,9-26.83C88.62,166.88,115.5,160.55,134.89,173Zm40.22,113.09c-10.42-8.78-26.68-9.07-40.45-3.43-22.13,9.07-34.59,31.69-23.43,53.16-3.63-18.81,10.23-36.69,27-43.74,14.29-6,30.85-6.29,41.18,3.75C178,292.83,176.58,289.57,175.11,286.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1161.56,354.38c-31.65,23.63-112.7,6-131.07-21-3.49-5.13-5.75-11.1-4.61-18.81-.59-2.39,38.66-111.85,41.88-139.15,2.4,31.86,93.65,38.3,116.4,32,7.54,32.56,5.77,127.68-22.6,147Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1096.43,274.92c6.31-28.29-18.85-44.36-47.87-45.56-8.94,41.16-15.94,61.49-22.69,85.17,8.55-29.11,63.85-9.52,70.56-39.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1158.43,156.63c-8.92,36.16-38.1,119.48-54.59,150.75,15.5-20.35,49.2-13.24,62,6.27,7,10.68,8.53,30.18-4.26,40.73,4.29-2.43,16.37-11.95,21.93-34.49,7.81-31.58,28.53-89.11,44.4-121.92,15.95-33-36.73-63.27-69.46-41.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1195.63,150.51a54,54,0,0,1,22,10.53c-9.26,12-55.09,131.21-54,149.73A43.43,43.43,0,0,0,1142.47,297c12.76-21.64,50-132.47,53.16-146.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1217.42,172.52c-14.29-14.39-41.42-20.63-61.12-7.76-.71,2.61-1.5,5.37-2.34,8.27,19.4-12.48,46.27-6.15,60.24,8.31,7.06,7.27,11,17,8.94,26.83q1.6-3.55,3.15-6.86C1229.21,190.65,1225.17,180.29,1217.42,172.52ZM1154.2,282.69c-13.78-5.64-30-5.35-40.46,3.43-1.47,3.45-2.91,6.71-4.29,9.74,10.33-10,26.89-9.75,41.18-3.75,16.76,7.05,30.62,24.93,27,43.74C1188.78,314.38,1176.32,291.76,1154.2,282.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M140.14,84.92c-6.08,6.61-6.34,17.26-.67,27.88C165.76,162,186.29,241,192.42,274.92c-2.25-12.54,7.75-22.91,27.76-30.9,58.75-23.47,154.41-35.2,424.25-35.2V25.08c-320.85,0-467.53,20-504.29,59.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1148.71,84.92c6.08,6.61,6.34,17.26.67,27.88-26.29,49.2-46.82,128.15-53,162.12,2.25-12.54-7.75-22.91-27.76-30.9-58.74-23.47-154.41-35.2-424.25-35.2V25.08c320.85,0,467.53,20,504.29,59.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M644.43,187.2c-275.84,0-377.51,12.7-433.66,38.1-13.68,5.83-22.08,13.08-24.39,21.48,1,4.21,1.93,8.21,2.76,12,1.5-9.52,10.66-17.63,26.34-24.09C272.92,210.23,371.59,198,644.43,198h.47V187.2ZM149.56,103.64c39.34-38,180-56.94,494.87-56.94h.47V35.89h-.47c-317.85,0-461.53,19.46-499.58,58.39-4.76,4.61-6.63,11.11-5.54,18.21l.16.31q1.56,2.92,3.1,6a20.12,20.12,0,0,1,7-15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M645.37,187.2c275.84,0,377.51,12.7,433.66,38.1,13.67,5.83,21.25,12.41,23.56,20.82-1,4.2-1.89,8.14-2.72,11.9-1.5-9.52-9.87-16.9-25.55-23.36C1016.87,210.23,918.21,198,645.37,198h-.47V187.2Zm494.87-83.56c-39.34-38-180-56.94-494.87-56.94h-.47V35.89h.47c317.85,0,461.53,19.46,499.58,58.39,4.76,4.61,6.89,8.58,5.8,15.68,0,.11-2.59,5.1-3.61,7.13-.12-5.88-2.37-9.49-6.9-13.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1148.71,84.92C1112,45,965.27,25.08,644.43,25.08h0c-320.84,0-467.52,20-504.28,59.84-6.08,6.61-6.34,17.26-.67,27.88C165.76,162,186.29,241,192.42,274.92c-2.25-12.54,7.75-22.91,27.76-30.9,58.75-23.47,154.41-35.2,424.25-35.2s365.5,11.73,424.24,35.2c20,8,30,18.36,27.76,30.9,6.13-34,26.66-112.92,53-162.12C1155.05,102.18,1154.79,91.53,1148.71,84.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M400.82,113.11l-.9,42a7.13,7.13,0,0,1-7.13,7h-.15a7.14,7.14,0,0,1-7-7.29l0-1.16c-9.51,5-17.63,6.83-24.36,6.83a33.88,33.88,0,0,1-14.75-3.26c-11.8-5.65-19.54-18.24-20.7-33.66-1.31-17.32,6.05-33.63,19.19-42.56,23.69-16.11,44.15-6.53,54.47,6.57a7.14,7.14,0,0,1-11.22,8.83c-4.25-5.39-16.19-16.54-35.23-3.6-10.67,7.26-13.7,20.09-13,29.69.77,10.11,5.61,18.49,12.64,21.86,8.49,4.06,20,1.44,33.3-7.58l.26-12.26A116,116,0,0,1,361,130.59a7.14,7.14,0,0,1-1.58-14.19c.18,0,19.06-2.22,30.41-9.46a7.14,7.14,0,0,1,11,6.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M473.88,162a7,7,0,0,1-2.16.34,7.15,7.15,0,0,1-6.8-5L455.58,128l-25.9,10.43L421.33,158a7.14,7.14,0,0,1-13.14-5.59l9.51-22.37h0l23.11-54.33a7.15,7.15,0,0,1,13.38.64L464.53,109l3-1.22A7.14,7.14,0,1,1,472.9,121l-4,1.62,9.67,30.46A7.14,7.14,0,0,1,473.88,162Zm-22.63-47.71-4.84-15.26-8.83,20.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M560.55,163.69a7.15,7.15,0,0,1-8.66-5.21c-1.31-5.27-1.77-33.75-1.92-55.64a337.89,337.89,0,0,0-16.64,35.59,7.14,7.14,0,0,1-12.71,1.09L503.13,111.1c.05,2.86.1,6,.15,9.47.22,16.86.22,33.34.22,33.5a7.14,7.14,0,1,1-14.27,0c0-30-.56-63.64-1.48-68.4a7.14,7.14,0,0,1,12.91-5.83l24.88,40.44c1.61-3.62,3.5-7.74,5.55-12,11.77-24.29,18.22-30.42,22-32.92a7.14,7.14,0,0,1,11,6c0,32.65.59,69.14,1.58,73.7A7.12,7.12,0,0,1,560.55,163.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M638.1,156.34c-2.91.67-25.82,5.8-39.7,5.8a34.56,34.56,0,0,1-5.39-.36c-11.66-1.86-14.07-17.84-14.86-29.7-.29-4.27-.41-9.05-.37-14.3v0c.07-7.56.47-16.1,1.21-25.57a21,21,0,0,1,8.68-15.85c13.8-10,39.21-4.16,42.06-3.46a7.14,7.14,0,0,1-3.38,13.87c-8.33-2-23.91-3.48-30.32,1.16a6.74,6.74,0,0,0-2.81,5.4c-.47,6-.78,11.28-1,16,8.61-1.35,22-3.06,32.85-2.77a7.14,7.14,0,1,1-.39,14.27c-10.7-.29-24.82,1.71-32.62,3,.36,17.75,3,22.85,3.79,24,7.65.85,27.8-2.78,39-5.34a7.13,7.13,0,1,1,3.18,13.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M753.31,117.28a46.94,46.94,0,0,1-10.94,30.12c-6.86,8.2-15.84,13.21-24.64,13.75-.52,0-1,0-1.54,0a23.55,23.55,0,0,1-17.47-7.67c-5.11-5.48-8.34-13.52-9.59-23.89-4.65-38.55,18.6-50.46,28.81-53.79a23.25,23.25,0,0,1,24.83,6.64C749.74,90.27,753.28,102,753.31,117.28Zm-14.28,0c0-14.57-3.76-21.79-6.89-25.29a9,9,0,0,0-6.76-3.08,9.67,9.67,0,0,0-3,.49C712,92.81,700.2,102.25,703.3,127.93c.89,7.34,3.83,19.56,13.56,19,4.82-.3,10.27-3.53,14.56-8.66A32.62,32.62,0,0,0,739,117.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M819.74,76.16a7.15,7.15,0,0,1-.58,10.08c-10.53,9.39-18.11,43.82-20.41,63.31a7.14,7.14,0,0,1-4.84,5.94,7.3,7.3,0,0,1-2.25.36,7.15,7.15,0,0,1-5.18-2.22c-7.47-7.89-14.27-22.75-20.21-44.16C762,94,759.73,80.87,759.64,80.32a7.14,7.14,0,0,1,14.08-2.39c1.73,10.18,6.83,33.59,14,50.5.61-3.08,1.32-6.37,2.14-9.76,5.15-21.5,11.8-36,19.75-43.09a7.15,7.15,0,0,1,10.08.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M888.69,156.34c-2.91.67-25.83,5.8-39.7,5.8a34.7,34.7,0,0,1-5.4-.36c-11.65-1.86-14.06-17.84-14.86-29.7-.29-4.27-.4-9.05-.36-14.3v0c.06-7.56.46-16.1,1.2-25.57a21,21,0,0,1,8.69-15.85c13.8-10,39.21-4.16,42.06-3.46a7.14,7.14,0,1,1-3.39,13.87c-8.32-2-23.91-3.48-30.31,1.16a6.72,6.72,0,0,0-2.81,5.4c-.47,6-.78,11.28-1,16,8.61-1.35,22-3.06,32.84-2.77a7.14,7.14,0,1,1-.38,14.27c-10.7-.29-24.82,1.71-32.63,3,.37,17.75,3,22.85,3.8,24,7.65.85,27.79-2.78,39-5.34a7.13,7.13,0,1,1,3.18,13.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M971.52,157.58a7.14,7.14,0,0,1-9.9,2l-44.07-29.38c0,12.3-.14,23-.66,26.68a7.15,7.15,0,0,1-7.06,6.13,7,7,0,0,1-1-.07,7.15,7.15,0,0,1-6.06-8.08c.93-6.45.47-47.39-.07-73.34a7.14,7.14,0,0,1,7-7.28,7,7,0,0,1,3.11.64A80,80,0,0,1,925,72.42c17.29-2,25.74,4.14,29.78,9.59a14.23,14.23,0,0,1,2.34,12.55c-2,7.2-9.58,14.43-23.12,22.1-2.1,1.19-4.16,2.29-6.11,3.28l41.62,27.74A7.14,7.14,0,0,1,971.52,157.58ZM917.4,109.21c3.13-1.49,7-3.46,10.87-5.7,13.52-7.88,15-12.27,15.15-12.89l-.08-.1c-4.48-6-17.62-4.45-26.25-2.08C917.19,93.71,917.31,101.14,917.4,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M980.32,133.16c-1.37-13.31-.09-50.27,0-51.84a7.14,7.14,0,0,1,14.27.5c0,.38-1.31,37.54,0,49.87a7.14,7.14,0,0,1-6.36,7.84q-.37,0-.75,0A7.14,7.14,0,0,1,980.32,133.16Zm.41,19.34a7.14,7.14,0,1,1,7.14,7.14A7.14,7.14,0,0,1,980.73,152.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameover02);
export default __webpack_public_path__ + "static/media/game over-02.998493a846815d2fa38067304ca07f59.svg";
export { ForwardRef as ReactComponent };